export default "__VITE_ASSET__BfcxKtdj__"